import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getCompanySettings } from '../services/api';

const fallbackCompany = {
  site_name: 'PT CITRA HERITAGE INDONESIA',
  site_tagline: 'Engineering Excellence & Remanufacturing Solutions',
  company_name: 'PT CITRA HERITAGE INDONESIA',
  company_address: 'Jl. Sultan Hasanudin No.17 KM 5.5, Kariangau Balikpapan - Indonesia 76134',
  company_phone: '+62 21 1234 5678',
  company_email: 'sales.parts@andalanfluids.com',
  company_whatsapp: '628123456789',
  company_website: 'https://afs-manufaktur.com',
  social_instagram: 'https://www.instagram.com/andalanfluidsistem/?hl=en',
  social_facebook: null,
  social_linkedin: null,
  social_youtube: null,
};

const Footer = () => {
  const [company, setCompany] = useState(fallbackCompany);

  useEffect(() => {
    getCompanySettings().then(data => {
      if (data && data.company_name) {
        setCompany(prev => ({ ...prev, ...data, logo: data.logo || prev.logo || '/logo.png', logo_footer: data.logo_footer || prev.logo_footer || '/logo.png' }));
      }
    }).catch(() => {});
  }, []);

  return (
    <footer>
      <div className="wrap">
        <div className="ft-top">
          {/* Brand Column */}
          <div className="ft-brand">
            <div style={{display:'flex',alignItems:'center',gap:'12px',marginBottom:0}}>
              {(company.logo_footer || company.logo || "/logo.png") ? (
                <img src={company.logo_footer || company.logo || "/logo.png"} alt={company.company_name || 'PT CITRA HERITAGE INDONESIA'} style={{height:'48px',width:'auto',objectFit:'contain'}} />
              ) : (
                <>
                  <div className="logo-box" style={{height:'48px',width:'42px'}}>
                    <div className="logo-initials" style={{color:'var(--ink)'}}>AFS</div>
                  </div>
                  <div className="logo-wordmark">
                    <strong style={{color:'var(--white)',fontSize:'16px'}}>{company.name || 'PT CITRA HERITAGE INDONESIA'}</strong>
                    <span style={{color:'rgba(255,255,255,0.3)'}}>Remanufacturing</span>
                  </div>
                </>
              )}
            </div>
            <p className="ft-tagline">Engineering Excellence &amp; Remanufacturing Solutions</p>
            <div className="ft-socials">
              <a className="soc" href={company.social_facebook || '#'} target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </a>
              <a className="soc" href={company.social_instagram || '#'} target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
              </a>
              <a className="soc" href={company.social_linkedin || '#'} target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
              </a>
              <a className="soc" href={company.social_youtube || '#'} target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
              </a>
            </div>
          </div>
          {/* Company Column */}
          <div>
            <div className="ft-col-title">Company</div>
            <ul className="ft-links">
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/components">Our Client</Link></li>
              <li><Link to="/services">Service</Link></li>
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/careers">Careers</Link></li>
            </ul>
          </div>
          {/* Contact Column */}
          <div>
            <div className="ft-col-title">Contact</div>
            <div className="ft-contact-block">
              <div className="ft-contact-label">OFFICE ADDRESS</div>
              <p className="ft-contact-val">{company.company_address || 'Jl. Sultan Hasanudin No.17 KM 5.5, Kariangau Balikpapan - Indonesia 76134'}</p>
            </div>
            <div className="ft-contact-block">
              <div className="ft-contact-label">PHONE</div>
              <p className="ft-contact-val">{company.company_phone || '+62 21 1234 5678'}</p>
            </div>
            <div className="ft-contact-block">
              <div className="ft-contact-label">WHATSAPP</div>
              <p className="ft-contact-val">
                <a href={`https://wa.me/${(company.company_whatsapp || '6281234567890').replace(/[^0-9]/g,'')}`} target="_blank" rel="noopener noreferrer" style={{color:'inherit',textDecoration:'none'}}>
                  {company.company_whatsapp || '+62 812 3456 7890'}
                </a>
              </p>
            </div>
            <div className="ft-contact-block">
              <div className="ft-contact-label">EMAIL</div>
              <p className="ft-contact-val">{company.company_email || 'sales.parts@andalanfluids.com'}</p>
            </div>
          </div>
          {/* Subscribe Column */}
          <div>
            <div className="ft-col-title">Subscribe</div>
            <p className="ft-subscribe-text">Stay up to date with our latest engineering news and projects.</p>
            <form className="ft-subscribe-form" onSubmit={(e) => e.preventDefault()}>
              <input type="email" placeholder="Enter your email" className="ft-subscribe-input" />
              <button type="submit" className="ft-subscribe-btn">Subscribe</button>
            </form>
            <p className="ft-subscribe-note">No spam, only occasional updates.</p>
          </div>
        </div>
        <div className="ft-bottom">
          <span>&copy; {new Date().getFullYear()} PT CITRA HERITAGE INDONESIA. All Rights Reserved.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
